import { render, staticRenderFns } from "./prescriptionList.vue?vue&type=template&id=c8854cc4&scoped=true"
import script from "./prescriptionList.vue?vue&type=script&lang=js"
export * from "./prescriptionList.vue?vue&type=script&lang=js"
import style0 from "./prescriptionList.vue?vue&type=style&index=0&id=c8854cc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8854cc4",
  null
  
)

export default component.exports